import React from 'react';
import styles from './NameTenat.module.scss';

const NameTenat = ({ value, title = '' }) => {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{value || '-'}</div>
    </div>
  );
};

export default NameTenat;
